export default __webpack_public_path__ + "static/media/r2.64c80eac.jpg";